import { useEffect, useRef, useState } from "react";

import Guest1Img from "../../assets/images/conversations/ep-56-ranjit-kulkarni-guest.webp";
import Guest2Img from "../../assets/images/conversations/ep-56-ravin-mirchandani-guest.webp";
import ThumbImg  from "../../assets/images/conversations/056.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: rk-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rk-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .rk-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .rk-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .rk-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rk-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .rk-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rk-hero__title.rk-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rk-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rk-hero__spotify.rk-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rk-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .rk-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rk-hero__right.rk-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .rk-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .rk-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .rk-yt-thumb:hover img { opacity: 0.85; }
  .rk-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .rk-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .rk-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .rk-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .rk-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rk-body.rk-visible { opacity: 1; transform: translateY(0); }
  .rk-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .rk-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (2 guests)
  ══════════════════════════════════════ */
  .rk-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rk-guest.rk-visible { opacity: 1; transform: translateY(0); }
  .rk-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .rk-guest__grid {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
  .rk-guest__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    max-width: 445px;
  }
  .rk-guest__photo-bg {
    width: 100%;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .rk-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .rk-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rk-inner { padding-left: 32px; padding-right: 32px; }
    .rk-hero { padding-top: 32px; padding-bottom: 48px; }
    .rk-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rk-hero__title { font-size: 24px; }
    .rk-hero__left { gap: 16px; }
    .rk-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rk-guest__grid { gap: 20px; }
    .rk-guest__photo-bg { width: 100%; height: 300px; }
    .rk-guest__name { font-size: 24px; margin-top: 18px; }
    .rk-body__para { font-size: 14px; margin-bottom: 12px; }
    .rk-body { padding-bottom: 48px; }
    .rk-guest { padding-bottom: 48px; }
    .rk-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rk-inner { padding-left: 16px; padding-right: 16px; }
    .rk-hero { padding-top: 51px; padding-bottom: 30px; }
    .rk-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .rk-hero__left { gap: 30px; }
    .rk-hero__title { font-size: 30px; }
    .rk-body__para { font-size: 16px; margin-bottom: 10px; }
    .rk-guest__title { font-size: 30px; margin-bottom: 20px; }
    .rk-guest__grid { flex-direction: column; gap: 30px; }
    .rk-guest__card { max-width: 100%; align-items: flex-start; }
    .rk-guest__photo-bg { width: 100%; height: 386px; }
    .rk-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rk-body { padding-bottom: 30px; }
    .rk-guest { padding-bottom: 30px; }
    .rk-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rk-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "InRODGsCSV4";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="rk-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 56 Ranjit Kulkarni"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="rk-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 56 Ranjit Kulkarni thumbnail" />
      <div className="rk-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rk-hero">
      <div className="rk-inner">
        <div className="rk-hero__grid">
          <div className="rk-hero__left">
            <h1 ref={titleRef} className="rk-hero__title">
              EP 56 | Fuels of the future with Honeywell | Ranjit KULKARNI
            </h1>
            <div ref={spotifyRef} className="rk-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/122EvNLroaFoZHlWxF3MHa?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 56 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rk-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rk-body">
      <div className="rk-inner">
        <p className="rk-body__para">
          On Energizing India, we speak with key protagonists in the energy transition and clean mobility sectors to uncover what works, what often doesn't, and to hear from those who have faced the toughest challenges. While we frequently discuss topics like lithium, hydrogen, and electric mobility, there is another part of the energy transition sector that quietly contributes to making the world a better place to live, even if it doesn't grab the headlines or generate widespread excitement.
        </p>
        <p className="rk-body__para">
          In today's episode, we've decided to shine a spotlight on the role of biofuels—such as ethanol-enriched gasoline, 100% biodiesel, and the increasingly promising sustainable aviation fuel. These innovations hold the potential to alleviate some of the guilt associated with frequent travel.
        </p>
        <p className="rk-body__para">
          Joining us is Ranjit Kulkarni, Vice President and General Manager of Honeyworld's Energy and Sustainable Solutions portfolio. He leads the company's operations in India and brings valuable insights into this crucial segment of the energy transition.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rk-guest">
      <div className="rk-inner">
        <h2 className="rk-guest__title">Our Guest</h2>
        <div className="rk-guest__grid">
          <div className="rk-guest__card">
            <div className="rk-guest__photo-bg">
              <img src={Guest1Img} alt="Ranjit Kulkarni" />
            </div>
            <p className="rk-guest__name">Ranjit KULKARNI</p>
          </div>
          <div className="rk-guest__card">
            <div className="rk-guest__photo-bg">
              <img src={Guest2Img} alt="Ravin Mirchandani" />
            </div>
            <p className="rk-guest__name">Ravin MIRCHANDANI</p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep56RanjitKulkarni() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rk-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}